import {h, Fragment} from "preact"
import { useFacet, useAppState } from "@nosto/preact";
import { useState, useEffect } from "preact/hooks";
import Icon from "./elements/Icon";

export default function FacetColor({ facet }) {
    const { toggleProductFilter } = useFacet(facet);
    const { query } = useAppState();
    const [activeSelect, setActiveSelect] = useState(true);
    const [showAll, setShowAll] = useState(false); 
    const [locationSplit, setLocationSplit] = useState(location.pathname.split('/')); 
    // const initialVisibleCount = 10; 

    
    // const visibleItems = showAll ? facet.data : facet.data?.slice(0, initialVisibleCount);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 768px)");
    
        const handleMediaChange = (e) => {
            setActiveSelect(e.matches);
        };
    
        handleMediaChange(mediaQuery);
    
        mediaQuery.addEventListener("change", handleMediaChange);
    
        return () => {
            mediaQuery.removeEventListener("change", handleMediaChange);
        };
    }, []);

    return (
        <li class={`ns-sidebar-dropdown pd-sidebar-dropdown ${activeSelect ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-pt-4 ns-pb-2"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={() => setActiveSelect(!activeSelect)}
            >
                <span class="ns-color-black ns-font-5 pd-text-uppercase">{facet.name}</span>
                <Icon name="arrow" className="ns-absolute" />
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-py-4">
                <ul class="ns-d-flex ns-flex-wrap ns-list-unstyled ns-p-0 ns-m-0">
                    {facet.data?.map((value) => (
                        <li
                            class="ns-d-flex ns-align-items-center ns-font-3 ns-mr-5"
                            data-nosto-element="facet-setting"
                        >

                            <a style={{ backgroundColor: value.value || "transparent" }}
                                    href="javascript:void(0)"
                                    onClick={(e) => {
                                        e.preventDefault();
    
                                        facet.data?.forEach((item) => {
                                            if (item.selected && item.value !== value.value) {
                                                toggleProductFilter(facet.field, item.value, false);
                                            }
                                        });
    
                                        toggleProductFilter(facet.field, value.value, !value.selected);
                                        
                                        if(!query.query) {
                                            window.location.replace(
                                                `/${locationSplit[1]}/${locationSplit[2]}/${value.value.toLowerCase()}${location.search}`
                                            );
                                        }
                                    }}
                                class={`pd__palette__color pd__palette__color--${value.value.toLowerCase().split(' ').join('-')}`}
                                ></a>
                        </li>
                    ))}
                </ul>
                {/* Botón Show More / Show Less */}
                {/* {facet.data?.length > initialVisibleCount && (
                    <button
                        class="pd-button ns-d-block ns-mt-4 ns-font-5"
                        onClick={() => setShowAll(!showAll)}
                    >
                        <Icon name={showAll ? "minus" : "plus"} />
                        {showAll ? "Show Less" : "Show More"}
                    </button>
                )} */}
            </div>
        </li>
    );
}
